/**
 * Che cosa dire all'utente quando la scrittura del nickname fallisce.
 *
 * ═══ PERCHE' ESISTE ═══
 * Fino al 2026-09-10 il `catch` in `WelcomeStep` era **vuoto** e il wizard proseguiva:
 * chi sceglieva un nickname **gia' preso** credeva di averlo, e non ce l'aveva. E il
 * segnale positivo (`haptics.success`) stava **solo** nel ramo riuscito, quindi in caso
 * di errore l'utente non riceveva **niente** — *un fallimento indistinguibile da un
 * successo silenzioso*, che e' la forma peggiore perche' non fa nemmeno sospettare.
 *
 * ═══ 🔴 «NON LO SO» E' UN ESITO, E NON SI COLLASSA SU «GIA' PRESO» ═══
 * Dire «gia' preso» quando non lo sappiamo **manda l'utente a cambiare un nome che
 * andava bene**: un guasto di rete non e' un conflitto. I tre esiti stanno separati
 * apposta, ed e' la stessa regola dei cinque stati vuoti dei pannelli della Hub —
 * *non si afferma cio' che non si e' chiesto.*
 *
 * ⚠️ **E il 409 sta per diventare un esito NORMALE**: col nickname su Limulo
 * (ADR-0125 `proposed`, backend gia' mergiato — `PUT /v1/me/nickname`, `409` duplicato,
 * formato `[a-z0-9_]` 3-32) il conflitto non e' piu' un caso limite ma la risposta
 * quotidiana. ⇒ un rimedio che si limitasse a **ritentare** non servirebbe a niente;
 * un errore **chiamato per nome** serve gia' oggi e servira' anche dopo.
 */
export type EsitoNickname = 'gia-preso' | 'formato' | 'sconosciuto';

/** Lo `status` di un errore RTK Query, quando c'e' ed e' un numero HTTP. */
function statoHttp(err: unknown): number | null {
  if (typeof err !== 'object' || err === null) return null;
  const s = (err as { status?: unknown }).status;
  // ⚠️ RTK Query mette in `status` anche stringhe (`FETCH_ERROR`, `PARSING_ERROR`,
  // `TIMEOUT_ERROR`): non sono codici HTTP, e trattarle come tali significherebbe
  // leggere un guasto di rete come una risposta del server.
  return typeof s === 'number' ? s : null;
}

export function esitoScritturaNickname(err: unknown): EsitoNickname {
  const s = statoHttp(err);
  if (s === 409) return 'gia-preso';
  if (s === 400 || s === 422) return 'formato';
  return 'sconosciuto';
}
